import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import styles from '../../styles/Building MGMT/UnitOfferManagement.module.css';

const initialState = {
  activeOffers: [],
  onTheClock: [],
  queue: [
    { id: 'applicant-1', name: 'Applicant 1' },
    { id: 'applicant-2', name: 'Applicant 2' },
    { id: 'applicant-3', name: 'Applicant 3' },
  ]
};

const UnitOfferManagement = () => {
  const [applicants, setApplicants] = useState(initialState);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const [offerSettings, setOfferSettings] = useState({
    clockTimeHours: 6,
    autoRejectDays: 2,
    uncountedStart: '00:00',
    uncountedEnd: '06:00'
  });

  const handleDragEnd = ({ source, destination }) => {
    if (!destination) return;
    if (source.droppableId === 'onTheClock' || destination.droppableId === 'onTheClock') return;
    if (destination.droppableId !== 'activeOffers' && source.droppableId !== destination.droppableId) return;

    setApplicants(prev => {
      const srcList = Array.from(prev[source.droppableId]);
      const [moved] = srcList.splice(source.index, 1);

      if (source.droppableId === destination.droppableId) {
        srcList.splice(destination.index, 0, moved);
        return { ...prev, [source.droppableId]: srcList };
      }

      const destList = Array.from(prev[destination.droppableId]);
      destList.splice(destination.index, 0, moved);

      return {
        ...prev,
        [source.droppableId]: srcList,
        [destination.droppableId]: destList,
      };
    });
  };

  const handleSettingsSave = () => {
    console.log(offerSettings);
    setSettingsOpen(false);
  };

  return (
    <div>
      <div className={styles.header}>
        <h2>Offer Management</h2>
        <button className={styles.settingsButton} onClick={() => setSettingsOpen(true)}>
          ⚙️ Settings
        </button>
      </div>

      <div className={styles.container}>
        <DragDropContext onDragEnd={handleDragEnd}>
          {["activeOffers", "onTheClock", "queue"].map((listId) => (
            <div className={styles.column} key={listId}>
              <h3 className={styles.columnTitle}>
                {listId === 'activeOffers' && '✅ Currently Active Offers'}
                {listId === 'onTheClock' && '⏳ On the Clock'}
                {listId === 'queue' && '🕒 Upcoming Queue'}
              </h3>
              <Droppable droppableId={listId}>
                {(provided) => (
                  <div className={styles.applicantList} ref={provided.innerRef} {...provided.droppableProps}>
                    {applicants[listId].map((applicant, index) => (
                      <Draggable key={applicant.id} draggableId={applicant.id} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            className={`${styles.applicantCard} ${snapshot.isDragging ? styles.dragging : ''}`}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            {applicant.name}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          ))}
        </DragDropContext>
      </div>

      {settingsOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h2>Offer Settings</h2>

            <label>
              ⏳ Clock Time (hours):
              <input
                type="number"
                value={offerSettings.clockTimeHours}
                onChange={(e) => setOfferSettings({ ...offerSettings, clockTimeHours: e.target.value })}
              />
            </label>

            <label>
              ❌ Auto Reject Time (days):
              <input
                type="number"
                value={offerSettings.autoRejectDays}
                onChange={(e) => setOfferSettings({ ...offerSettings, autoRejectDays: e.target.value })}
              />
            </label>

            <label>
              🌙 Uncounted Hours Start:
              <input
                type="time"
                value={offerSettings.uncountedStart}
                onChange={(e) => setOfferSettings({ ...offerSettings, uncountedStart: e.target.value })}
              />
            </label>

            <label>
              🌙 Uncounted Hours End:
              <input
                type="time"
                value={offerSettings.uncountedEnd}
                onChange={(e) => setOfferSettings({ ...offerSettings, uncountedEnd: e.target.value })}
              />
            </label>

            <div className={styles.modalButtons}>
              <button onClick={handleSettingsSave}>Save Settings</button>
              <button onClick={() => setSettingsOpen(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitOfferManagement;
